const COLOR_CODES = {
  default: {
    color: 'info',
  },
  ACTION_NEEDED: {
    color: 'sun-yellow',
  },
  ACTION_REQUESTED: {
    color: 'info',
  },
  OUTCOME_POSITIVE: {
    color: 'success',
  },
  OUTCOME_NEGATIVE: {
    color: 'error',
  },
}

export const transformGraphNotification = graphNotification => {
  const color =
    COLOR_CODES[graphNotification.notification_intent_code] ||
    COLOR_CODES.default
  return {
    ...graphNotification,
    message: graphNotification.content,
    rawHtml: graphNotification.content,
    timestamp: graphNotification.created_date,
    messageId: graphNotification.message_id,
    intentCode: graphNotification.notification_intent_code,
    read: graphNotification.read,
    ...color,
  }
}

export const markAsRead = notification => ({
  ...notification,
  read: true,
})
